'use client';

import Script from 'next/script';
import { useEffect } from 'react';

type GoogleAnalyticsProps = {
    gaId?: string;
};

export function GoogleAnalytics({ gaId }: GoogleAnalyticsProps) {
    useEffect(() => {
        if (!gaId) return;
    }, [gaId]);

    if (!gaId) {
        return null;
    }

    return (
        <>
            <Script
                src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
                strategy="afterInteractive"
            />
            <Script id="google-analytics" strategy="afterInteractive">
                {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', '${gaId}');
        `}
            </Script>
        </>
    );
}
